import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

const style = {
  grid: {
    padding: "0 15px !important",
  },
  noPadding: {
    padding: "0 !important",
  },
};

function GridItem({ ...props }) {
  const { classes, children, className, ...rest } = props;
  const classNames = [classes.grid, className];
  if (props.noPadding) {
    classNames.push(classes.noPadding);
  }
  return (
    <Grid item {...rest} className={classNames.join(" ")}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(GridItem);
